import React from "react";
import Navbar from "./Navbar";
import LiveChatWidget from "./LiveChatWidget";
import { useApp } from "../context/AppContext";
import { t } from "../lib/i18n";

export default function Layout({ children }) {
  const { lang } = useApp();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar/>
      <main className="flex-1">{children}</main>
      <LiveChatWidget/>
      <footer className="border-t border-white/10 py-8 mt-16">
        <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
          <div className="bg-[#1a0a0a] border border-[#a40606]/40 rounded-md px-4 py-3 text-xs text-[#ffb8b8] flex items-start gap-2 mb-6">
            <span className="text-base leading-none">🎰</span>
            <div>
              <strong className="text-white">Play Money · Social Casino</strong> — Havana Casino egy szórakoztató szociális kaszinó. A <strong>Gold Coins (GC)</strong> és <strong>Premium Coins (PC)</strong> virtuális zsetonok, kizárólag a játékélmény részei, <strong>készpénzre vagy más vagyontárgyra nem válthatók</strong>. A platform nem szerencsejáték — pénzbeli nyeremény nincs. 18+ szórakoztatás.
            </div>
          </div>
          <div className="text-xs text-white/40 flex flex-wrap items-center justify-between gap-4">
            <span>{t(lang, "landing.footer")}</span>
            <div className="flex flex-wrap items-center gap-4">
              <a href="/terms" data-testid="footer-terms" className="hover:text-[#d4af37] transition">Terms</a>
              <a href="/privacy" data-testid="footer-privacy" className="hover:text-[#d4af37] transition">Privacy</a>
              <a href="/responsible" data-testid="footer-responsible" className="hover:text-[#d4af37] transition">18+ Responsible</a>
              <a href="/casinos" data-testid="footer-casinos" className="hover:text-[#d4af37] transition">Reviews</a>
              <span className="font-serif tracking-widest text-[#d4af37]/60">"THE WORLD IS YOURS"</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
